import { styles as componentStyles } from './view.scss';
import { unsafeCSS } from 'lit';

export const styles = [unsafeCSS(`${componentStyles}`)];
